module.exports = __webpack_public_path__ + "static/img/ad7.d6002b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark40/ad7.png
// module id = i/Xo
// module chunks = 12